import { render, staticRenderFns } from "./SettledBankReturnScreen.vue?vue&type=template&id=79859510&scoped=true"
import script from "./SettledBankReturnScreen.vue?vue&type=script&lang=ts"
export * from "./SettledBankReturnScreen.vue?vue&type=script&lang=ts"
import style0 from "./SettledBankReturnScreen.vue?vue&type=style&index=0&id=79859510&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79859510",
  null
  
)

export default component.exports